import { render } from "./elem-form.vue?vue&type=template&id=75889ba1&ts=true"
import script from "./elem-form.vue?vue&type=script&lang=ts"
export * from "./elem-form.vue?vue&type=script&lang=ts"

import "./elem-form.vue?vue&type=style&index=0&id=75889ba1&lang=less"

import exportComponent from "/usr/local/share/applications/yushifu-shop-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__